<template>
  <nav
    class="tabs-group nav-pills"
    :class="size"
  >
    <ul>
      <li
        v-for="tab in tabs"
        :key="tab.key"
        class="nav-item"
      >
        <component
          :is="tab.externalLink ? 'a' : 'router-link'"
          class="nav-link"
          :class="{
            disabled: tab.disabled,
            active: tab.active,
          }"
          v-bind="attributes(tab)"
          @click.native="$emit('change', tab)"
        >
          <span
            v-if="tab.title"
            class="bold"
          >
            {{ tab.title }}
          </span>
          <component :is="tab.icon" />
          <Counter
            v-if="tab.notification > -1"
            :value="`${tab.notification}${tab.maxNotifications ? ' +' : ''}`"
            size="small"
          />
        </component>
      </li>
    </ul>
  </nav>
</template>

<script>
import { defineComponent } from "vue";
import Counter from "../../components/infos/Counter.vue";

/**
 * Affiche un groupe d'onglets avec son contenu.
 */
export default defineComponent({
  name: "TabsGroup",
  components: {
    Counter,
  },
  props: {
    /**
     * Onglets.
     */
    tabs: {
      type: Array,
      required: true,
    },
    /**
     * Taille globale.
     */
    size: {
      type: String,
      validator: (value) => ["small", "medium", "large"].includes(value),
      default: "medium",
    },
  },
  emits: [
    /**
     * Déclenché au changement d'onglet.
     */
    "change",
  ],
  methods: {
    /**
     * Définit les attributs de chaque bouton.
     * @param {Object} tab Onglet.
     */
    attributes(tab) {
      return tab.externalLink ? {
        href: tab.externalLink,
        target: "_blank",
        rel: "noreferrer noopener",
      } : {
        to: tab.routerLinkObj,
      };
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/anchors_tabs.scss";
</style>
